<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-header">
          <h5>DNS management</h5>
        </div>
        <div class="card-body">
          <div class="row">
              <!-- *** pole: dns name *** -->
              <div class="col-lg-3 col-md-3 col-12">
                  <input class="form-control" type="text" placeholder="dns name" [(ngModel)]=this.newDns.dnsName>
              </div>

              <!-- *** dropdown: publisher *** -->
              <div class="col-lg-3 col-md-3 col-12">
                <ng-multiselect-dropdown
                  [placeholder]="'--publishers--'"
                  [settings]="dropdownSettingsPublisher"
                  [data]="dropdownListPublisher"
                  [(ngModel)]="selectedItemsPublisher"
                  (onSelect)="onItemSelectPublisher($event)"
                  (onSelectAll)="onSelectAllPublisher($event)"
                  >
                </ng-multiselect-dropdown>
              </div>

              <!-- *** button +Add *** -->
              <div class="col-lg-1 col-md-1 col-12">
                <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="create new DNS" (click)="onAdd()">
                  <i class="fa fa-plus" aria-hidden="true"></i>Add</button>
              </div>

              <!-- *** tabela *** -->
              <div class="col-lg-9 col-md-9 col-12 custom-datatable">

                <ngx-datatable
                class="bootstrap"
                [rows]="dnsData"
                [columnMode]="ColumnMode.flex"
                [loadingIndicator]="true"
                [externalPaging]="true"
                [count]="page.totalElements"
                [offset]="page.pageNumber"
                [limit]="page.size"
                (page)="setPage($event)"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [selected]="selected"
                [selectionType]="SelectionType.single"
                (select)="onSelect($event)"
                >
                <ngx-datatable-column name="dnsName" [flexGrow]="2">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">DNS name (FQDN)</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.dnsName }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="email" [flexGrow]="2" [sortable]="false">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Assigned Publishers</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngFor="let publisher of row.publishers">
                      <div><a href="/adm/publishers/{{ publisher.id }}">{{publisher.firstName}} {{publisher.lastName}} </a><small>({{publisher.username}})</small></div>
                    </span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="phone" [flexGrow]="1" [sortable]="false">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Monitor</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                      <span *ngIf="row.monitor==1">
                        <i class="fa fa-check"></i>
                      </span>
                      <span *ngIf="row.monitor==0">
                        <i class="fa fa-warning"></i>
                      </span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="isDefault" [flexGrow]="1" [sortable]="false">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Default</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.isDefault==true">
                      <i class="fa fa-check"></i>
                    </span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="rating" [flexGrow]="1" [sortable]="false">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Status</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="row.dnsStatus=='on'">
                      <button class="btn btn-pill btn-xs btn-success" type="button" placement="top" name="btnStatus" (click)="onStatus(row)">
                        Active</button>
                    </div>
                    <div *ngIf="row.dnsStatus=='off'">
                      <button class="btn btn-pill btn-xs btn-danger" type="button" placement="top" name="btnStatus" (click)="onStatus(row)">
                        Disabled</button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [flexGrow]="1" [sortable]="false">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary">Action</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <button class="btn btn-pill btn-xs btn-info" type="button" placement="top" name="delete the DNS" (click)="onDelete(row)">
                      Delete</button>
                  </ng-template>
                </ngx-datatable-column>
                </ngx-datatable>
              
              </div>
          
              <!-- *** edycja wiersza DNS zaznaczonego w tabeli *** -->
              <div class="col-lg-3 col-md-3 col-12">
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="form-label">DNS name</label>
                    <input class="form-control" type="text" placeholder="dns name" [(ngModel)]="currentDns.dnsName">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="form-label">Publishers</label>
                    <ng-multiselect-dropdown
                    name="publisher"
                    [placeholder]="'--publishers--'"
                    [settings]="dropdownSettingsPublisher"
                    [data]="dropdownListEditPublisher"
                    [(ngModel)]="selectedEditPublisher"
                    (onSelect)="onItemSelectPublisher($event)"
                    (onSelectAll)="onSelectAllPublisher($event)"
                    >
                  </ng-multiselect-dropdown>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-lg-12 col-md-12 col-12">
                    <div class="checkbox checkbox-primary">
                      <div *ngIf="isDefaultDns==true">
                        <input id="checkDefault" type="checkbox" [(ngModel)]="isDefaultDns" disabled>
                        <label class="mb-0" for="checkDefault">Default DNS for system</label>
                      </div>
                      <div *ngIf="isDefaultDns==false">
                        <input id="checkDefault" type="checkbox" [(ngModel)]="isDefaultDns">
                        <label class="mb-0" for="checkDefault">Default DNS for system</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 col-md-12 col-12">
                    <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="update DNS" (click)="onUpdate()">
                      Update</button>
                  </div>
                </div>

              </div>

        </div>
      </div>
    </div>
</div>
<!-- Container-fluid Ends-->
